/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
var site = function () {
    this.configForm = function () {
        $('.mask-phone').mask('(00)000000009');
        $('.mask-date').mask('00/00/0000');
        $('.mask-schedule').mask('00:00');
        $('.mask-cpf').mask('000.000.000-00');
        $('.mask-cnpj').mask('00.000.000/0000-00');
        $('.mask-cep').mask('00000-000');
        $('.mask-money').mask('#.##0,00', { reverse: true });
        $('.custom-file-input').on('change', function () {
            var fileName = document.getElementById("f-attachment").files[0].name;
            $('.custom-file-label').text(fileName);
        })
    }

    this.scroll = function () {
        $('a:not(.lnk-tabpanel)[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = this.hash;
            var $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - 100
            }, 900, 'swing', function () {
                window.location.hash = target;
            });
        });
    };

    this.validate = function () {
        var objThis = this;
        if (typeof $.fn.validate === "function") {
            var formContact = $('#frm-contact');
            if (formContact.length) {
                formContact.validate({
                    submitHandler: function () {
                        objThis.send(formContact);
                    },
                    rules: {
                        txt_name: "required",
                        txt_phone: "required",
                        txt_email: "required",
                        txt_city: "required"
                    },
                    messages: {
                        txt_name: "Informe seu nome",
                        txt_phone: "Informe seu telefone",
                        txt_email: "Informe seu e-mail",
                        txt_city: "Informe sua cidade"
                    }
                });
            };
            var formContactExperimental = $('#frm-contact-experimental, #frm-contact-experimental-bimestral, #frm-contact-experimental-apresenta');
            if (formContactExperimental.length) {
                formContactExperimental.validate({
                    submitHandler: function () {
                        objThis.send(formContactExperimental);
                    },
                    rules: {
                        txt_name: "required",
                        txt_phone: "required",
                        txt_email: "required",
                        txt_city: "required",
                        r_level: "required",
                        r_interest: "required"
                    },
                    messages: {
                        txt_name: "Informe seu nome",
                        txt_phone: "Informe seu telefone",
                        txt_email: "Informe seu e-mail",
                        txt_city: "Informe sua cidade",
                        r_level: "Selecione seu provável nível",
                        r_interest: "O que deseja fazer?"
                    }
                });
            };

            var formTasting = $('#frm-tasting01, #frm-tasting02');
            if (formTasting.length) {
                formTasting.validate({
                    submitHandler: function () {
                        objThis.send(formTasting);
                    },
                    rules: {
                        txt_name: "required",
                        txt_phone: "required",
                        txt_email: "required",
                        txt_city: "required"
                    },
                    messages: {
                        txt_name: "Informe seu nome",
                        txt_phone: "Informe seu telefone",
                        txt_email: "Informe seu e-mail",
                        txt_city: "Informe sua cidade"
                    }
                });
            };

            var formContactReserve = $('#frm-contact-reserve');
            if (formContactReserve.length) {
                formContactReserve.validate({
                    submitHandler: function () {
                        objThis.send(formContactReserve);
                    },
                    rules: {
                        txt_name: "required",
                        txt_phone: "required",
                        txt_email: "required",
                        txt_city: "required",
                        r_level: "required",
                        r_interest: "required"
                    },
                    messages: {
                        txt_name: "Informe seu nome",
                        txt_phone: "Informe seu telefone",
                        txt_email: "Informe seu e-mail",
                        txt_city: "Informe sua cidade",
                        r_level: "Selecione seu provável nível",
                        r_interest: "O que deseja fazer?"
                    }
                });
            };
        }
    };

    this.send = function (form) {
        $('.msg-registration').remove();
        $('button.send', form).prop('disabled', true);
        var data = form.serialize();
        var labelButtomDefault = $('button.send', form).html();
        $('button.send', form).html('Aguarde!...');
        $.ajax({
            'url': 'https://www.masterenglish.com.br/contact/landing',
            type: 'POST',
            data: data,
            success: function (data) {
                console.log(data);
                $('.msg-registration').remove();
                try {
                    var r = JSON.parse(data);
                    if ('success' === r._return) {
                        form[0].reset();

                        var formId = form.attr('id');
                        /*
                        if (formId == 'frm-contact') {
                            gtag('event', 'conversion', {'send_to': 'AW-941751029/jN4xCMiY4l4Q9fWHwQM'});
                        }
                        if (formId == 'frm-uce') {
                            gtag('event', 'conversion', {'send_to': 'AW-941751029/wXSYCNi1vHIQ9fWHwQM'});
                        }
                         */
                        $('button.send', form).prop('disabled', false).html(labelButtomDefault);
                        form.append('<div class="msg-registration success">' + r._msg + '</div>');

                        if(r._redirect)
                            window.location.href = r._redirect

                    } else {
                        form.append('<div class="msg-registration error">Ops! algo deu errado.</div>');
                        $('button.send', form).prop('disabled', false).html(labelButtomDefault);
                    }
                } catch (e) {
                    form.append('<div class="msg-registration error">Ops! algo deu errado.</div>');
                    $('button.send', form).prop('disabled', false).html(labelButtomDefault);
                }
            },
            error: function () {
                $('.msg-registration').remove();
                $('button', form).append('<div class="msg-registration error">Ops! algo deu errado.</div>');
                $('button', form).prop('disabled', false).html(labelButtomDefault);
            }
        });
        return false;
    };
};

var objSite = new site();
$(window).on('load', function () {
    $('body').fadeIn(800);
});

$(window).on('resize', function () {});

$(function () {
    objSite.scroll();
    objSite.configForm();
    objSite.validate();
});